import styles from './Downloads.module.scss';

import { FiFileText } from 'react-icons/fi';
import Button from '../../common/Button/Button';
const Downloads = ({ onClose }) => {
  return (
    <div className={styles.modalOverlay}>
      <section className={styles.downloads}>
        <div className={styles.closeButtonWrapper}>
          <Button onClick={onClose}> X </Button>
        </div>
        <div className={styles.header}>
          <span className={styles.icon}>
            <FiFileText className={styles.fileIcon} />
          </span>
          <h1 className={styles.title}>Pliki do pobrania</h1>
        </div>
        <p className={styles.desc}>
          Dokumenty, materiały i zasoby dostępne do pobrania.
        </p>
        <div className={styles.list}>
          <a href='/downloads/Regulamin.pdf' download className={styles.item}>
            <span>Regulamin </span>
          </a>
          <a
            href='/downloads/Standardy Ochrony Dzieci.pdf'
            download
            className={styles.item}
          >
            <span>Standardy Ochrony Dzieci</span>
          </a>
          {/* <a href='/downloads/' download className={styles.item}>
            <span>Regulamin usługi</span>
          </a> */}
        </div>
      </section>
    </div>
    // </div>
  );
};

export default Downloads;
